import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface CreateFacilityScopeDto {
  scopeOfPractice: ScopeOfPracticeEnum; // Required
  isActive?: boolean; // Default true
}
